import React, { Component, createRef } from 'react';
import * as ManualStockAdjustmentAction from '../actions/ManualStkAdjAction';
import ManualStockAdjustmentStore from '../stores/ManualStkAdjStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next';
import * as MenuAction from '../actions/MenuAction';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import swal from 'sweetalert';
import { createReadStream } from 'fs';
import { parse } from 'date-fns/esm/fp';
import { tr } from 'date-fns/esm/locale';
let currentPagePath;
let isFromLink = false;
let strurlParams = "";
let qp = "";
let mob_Session_USERID = "";
let mob_Session_BUSUNIT = "";
let Token = "";
let Password = "";
let canShowDetail = false;
let showQrScanner = false;
/*[11/03/2024, PC_CPW_246_01, Vishwa S]*/
let SESSION_TRUCK_USER = "";
let mobItemID = "";
let isTruckCrib = false;
let isFromFieldInventory = false;
let ItemID = "";
let FieldUserId = "";
let IsInvalidItem = false;
let Region = "";
let Sub_Region = "";
let MfgPartName = "";
let MfgPartNum = "";


const urlParams = window.location.search;
if (urlParams.includes("?qp_mob")) {
    strurlParams = urlParams.toString()
    if (strurlParams.includes("?qp_mob")) {

        let StrURL = strurlParams.split("?qp_mob=")
        let DecodedQueryparams = StrURL[1].toString();
        qp = atob(DecodedQueryparams);
        let QueryParams = qp.split("&")
        console.log("query0", QueryParams[0])
        console.log("query1", QueryParams[1])
        mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
        mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
        console.log("querytest", QueryParams[2])
        Password = QueryParams[2].replace("Password=", "");
        console.log("passtest", Password)
        Token = QueryParams[3].replace("Token=", "");
        console.log("tokentest", Token)
        /*[11/03/2024, PC_CPW_246_02, Vishwa S]*/
        if (QueryParams.length >= 6) {
            SESSION_TRUCK_USER = QueryParams[5].replace("mob_SESSION_TRUCK_USER=", "");
        }
        if (QueryParams.length >= 7) {
            mobItemID = QueryParams[6].replace("mob_ITEMID=", "");
        }

        if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
            isFromLink = true;

            //Update the User ID and Token in cookie to invoke secure controller
            CookieService.updateLocalStorageValues("Session_UserID", mob_Session_USERID)
            CookieService.setCookieValues(SDIConstants.access_token, Token)
            console.log("ID", mob_Session_USERID)
            console.log("ID", Token)
        }
    }
}
class ManualStockAdjustmentComponent extends Component {
    constructor(props) {
        super(props);
        this.scannerRef = createRef()
        this.state = {
            GridArray: [],
            BinLocationDD: [],
            BinLocOptions: [],
            ReasonOptions: [],
            ReasDDName: "",
            ReasDDValue: "",
            SelectedArea: "",
            SelectedAisle: "",
            SelectedRow: "",
            SelectedShelf: "",
            SelectedBin: "",
            SelectedBU: "",
            SelectedAdjType: "",
            SelectedCurQty: "",
            AdjustedQty: "",
            Quantity: "",
            /*[11/03/2024, PC_CPW_246_03, Vishwa S]*/
            ItemID: isFromLink == true && mobItemID != "" && mobItemID != undefined && mobItemID != null ? mobItemID : "",
            Inc0Qtychk: isFromLink == true ? isTruckCrib : false,
            Document: "",
            AdjQuantity: "",
            ErrQuantity: "",
            ErrCost: "",
            isFavorited: false,
            isWorkToStoreValid: false,
            DecInventory: false,
            IncInventory: false,
            ItemDescription: "",
            AdjTypeName: "",
            AdjTypeValue: "",
            AdjTypeOptions: [],
            SerialId: "",
            SelectedUOM: "",
            AdjMessage: "",
            PhyInvMsg: "",
            SelectedRes: {},
            SelectedAdjTypes: {},
            truckLocation: "",
            default: { label: "Select", value: "" }, errorMsg: "", delay: 100,
            result: 'No result', QR: false, html5QrcodeScanner: "", results: [], facingMode: "environment",
            camera: "",
            disableInput: false,
            selectedIndex: null,
            isSelected: null,
            QuantityAvail: "",
            UnitCost: "",
            hasOpenPO: false,
            mobileStateData: {
                quantity: "",
                serialno: "",
                unitcount: "",
                SelectedQty: ""
            },
            itemErrorMsg: "",
            truckOrRackData: [],
            TruckDDvalue: "",
            TruckOptions: [],
            adjTypeErrorMsg: "",
            adjQtyErrorMsg: "",
            adjResonErrorMsg: "",
            adjNoteErrorMsg: "",
            isTruckId: false,
            selectedTruck: {},
            //PC-CPW-231_02
            minQty: "", adjQtyMsg: "",
            maxQty: "",
            minQtyErrorMsg: "",
            maxQtyErrorMsg: "", QRError: false, defTruckId: "", reorderRes: false,
            isFromFieldInventory: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ? true : false,
            itemMfg: "",
            itemMfgPartNo: ""
        }


        if (this.state.isFromFieldInventory) {
            isFromFieldInventory = this.props.location.state.isFromFieldInventory;
            ItemID = this.props.location.state.inv_item_id;
            FieldUserId = this.props.location.state.employee_id;
            Region = this.props.location.state.employee_region ;
            Sub_Region = this.props.location.state.employee_sub_region;
            MfgPartName = this.props.location.state.mfg_std;
            MfgPartNum = this.props.location.state.manufacturer_part_number;
        }
    }
    /***
     * MSA_PC_07
     * */
    componentDidMount() {
        // 5762 - checking the user selected crib or not at component mounting only.[4/25/2025] Nachiappan
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        if (cribID.trim() == "" || cribID == null || cribID == undefined) {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        $("#BarcodeSacnnerid").hide();
        IsInvalidItem = false;
        if (isFromFieldInventory && ItemID) {
            let truckLocation = this.props.location.state.isa_truck_id;
            let SearchItemBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ItemId: ItemID.toUpperCase().trim(),
                Inc0Qtyavail: this.state.Inc0Qtychk,
                UserId:  FieldUserId ,
                TruckLocation: this.props.location.state.isa_truck_id,
                IsTrucUser: CookieService.getLocalStorageValues("Session_TRUCK_USER"),
            };

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ManualStockAdjustmentAction.SearchItem(SearchItemBO);

            this.setState({ ItemID, truckLocation, isTruckId: isFromFieldInventory });
        }
        this.PageLoad();


        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        if (isFromFieldInventory) {
            CookieService.updateLocalStorageValues("FieldInventory_RegionDD", this.props.location.state.RegionDD);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionDD", this.props.location.state.SubRegionDD);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidDD", this.props.location.state.TruckidDD);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameDD", this.props.location.state.TechNameDD);
            CookieService.updateLocalStorageValues("FieldInventory_RegionValue", this.props.location.state.RegionValue);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionValue", this.props.location.state.SubRegionValue);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidValue", this.props.location.state.TruckidValue);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameValue", this.props.location.state.TechNameValue);
            CookieService.updateLocalStorageValues("FieldInventory_SearchTxt", this.props.location.state.SearchTxt);
            CookieService.updateLocalStorageValues("FieldInventory_UserId", this.props.location.state.UserId);
            CookieService.updateLocalStorageValues("FieldInventory_PageLoadData", this.props.location.state.PageLoadData);
            CookieService.updateLocalStorageValues("FieldInventory_IncludeZeroCheck", this.props.location.state.IncludeZeroCheck);
        }
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        if (!isFromLink) {
            ManualStockAdjustmentAction.getCurrentFavPage(getFavPageBO);
        }

        ManualStockAdjustmentStore.on('PageLoad', this.PageLoadResponse);
        ManualStockAdjustmentStore.on('SearchItem', this.SearchItemClickResponse);
        ManualStockAdjustmentStore.on('AdjConfSubmit', this.AdjConfSubmitClickResponse);
        ManualStockAdjustmentStore.on('favpage', this.loadFavPageResponse.bind(this));
        ManualStockAdjustmentStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

        //PC_CPW_231_03
        ManualStockAdjustmentStore.on('reorderdataResponse', this.reorderCheckResponse);
        ManualStockAdjustmentStore.on('submitReorderDataResponse', this.reorderSubmitResponse);
        $(document).on('click', '.accordion-toggle', function () {
            $('.collapse').not($(this).data('target')).collapse('hide');
        });
    }
    /***
     * MSA_PC_07
     * */
    componentWillUnmount() {
        isFromFieldInventory = false;
        ItemID = "";
        ManualStockAdjustmentStore.removeListener('PageLoad', this.PageLoadResponse);
        ManualStockAdjustmentStore.removeListener('SearchItem', this.SearchItemClickResponse);
        ManualStockAdjustmentStore.removeListener('AdjConfSubmit', this.AdjConfSubmitClickResponse);
        ManualStockAdjustmentStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        ManualStockAdjustmentStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));

        //PC_CPW_231_04
        ManualStockAdjustmentStore.removeListener('reorderdataResponse', this.reorderCheckResponse);
        ManualStockAdjustmentStore.removeListener('submitReorderDataResponse', this.reorderSubmitResponse);
        $(document).off('click', '.accordion-toggle');
    }

    /***
     * MSA_PC_09
     * */
    //This Method is used to get ReasonList to bind in the reason dropdown
    PageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let userId;
        if (isFromLink) {
            userId = mob_Session_USERID
        }
        else {
            userId = CookieService.getLocalStorageValues("Session_UserID")
        }
        let PageLoadBo = {
            UserID: isFromFieldInventory ? FieldUserId : CookieService.getLocalStorageValues("Session_UserID"),
        };
        ManualStockAdjustmentAction.PageLoad(PageLoadBo);
    }
    /***
    * MSA_PC_16
    * */
    //To Store Reason Data in an array
    PageLoadResponse = () => {

        let PageLoadData = JSON.parse(ManualStockAdjustmentStore.PageLoadData);
        canShowDetail = false;
        //WW-553 MSA_PC_02  Issue due to zero qty-Manual stk - Deepthi N H
        let CribArray = PageLoadData.UserDetails;
        let TruckRackData = PageLoadData.TruckIdTable;
        if (isFromFieldInventory) {
            CookieService.updateLocalStorageValues("FieldInventory_cleardata", true);
        } else {
            CookieService.updateLocalStorageValues("FieldInventory_cleardata", false);
        }
        if (!isFromFieldInventory) {
            if (CribArray[1].Data != null && CribArray[1].Data != "" && CribArray[1].Data != undefined) {
                this.setState({ truckLocation: CribArray[1].Data, defTruckId: CribArray[1].Data });
            }
        }
        let ReasonDD = PageLoadData.ReasonDD;
        this.ReasonDD(ReasonDD);
        //To change radio buttons to dropdown - Deepthi N H
        this.BindAdjustmentTypes();
        this.BindTruckRackDD(TruckRackData)
        /*[11/03/2024, PC_CPW_246_04, Vishwa S]*/
        //if (!isFromLink) {
        //    $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //}
        if (isFromLink == true) {
            if (CribArray[0].Data != undefined && CribArray[0].Data != null && CribArray[0].Data != "" && CribArray[0].Data == "0W0T") {
                isTruckCrib = true;
            }
            if (this.state.ItemID != "") {
                this.SearchItemClick(this.state.Inc0Qtychk);
            }
            this.setState({ Inc0Qtychk: isTruckCrib });
        }
        if (!isFromFieldInventory) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }

    BindTruckRackDD = (TruckRack) => {
        let TruckDDvalue = []
        let TruckDD = []
        if (TruckRack.length > 0) {
            TruckRack.forEach((value, index) => {

                if (value.ISA_TRUCK_ID == this.state.truckLocation) {
                    let loc = {
                        value: value.ISA_TRUCK_ID,
                        label: value.STORAGE_AREA
                    }
                    TruckDD.push(loc)
                }
                let locObj = {
                    value: value.ISA_TRUCK_ID,
                    label: value.STORAGE_AREA
                }
                TruckDDvalue.push(locObj);
            });
        }
        this.setState({ TruckOptions: TruckDDvalue, TruckDDName: { value: this.state.truckLocation, label: this.state.truckLocation } })
    }

    handleTruckDDChange = (values) => {
        let truckLoc = values.label;
        this.setState(
            { TruckDDName: values, truckLocation: truckLoc, isTruckId: true },
            () => {
                this.SearchItemClick(this.state.Inc0Qtychk);
            }
        )
    }

    /***
    * MSA_PC_16
    * */
    //To handle the Reason DropDown when it was changed
    handleReasDDChange = (values) => {

        this.setState(
            { ReasDDValue: values.value, ReasDDName: values, SelectedRes: values, adjResonErrorMsg: "" });
    }
    //To change radio buttons to dropdown - Deepthi N H
    handleAdjTypeDDChange = (values) => {

        let qty = parseInt(this.state.SelectedCurQty);
        let selectedQty = parseInt(this.state.AdjQuantity)
        if (values.value == "Inc") {
            if (qty < selectedQty) {
                this.setState({ adjQtyMsg: "Adjusted quantity will be more than the maximum", adjQtyErrorMsg: "" })
            }
            else {
                this.setState({ adjQtyMsg: "" })
            }
        }
        else {
            this.setState({ adjQtyMsg: "" })
        }

        this.setState(
            { AdjTypeName: values.value, AdjTypeValue: values, SelectedAdjTypes: values, adjTypeErrorMsg: "" });
    };
    //To change radio buttons to dropdown - Deepthi N H
    BindAdjustmentTypes = () => {

        let AdjTypeValue = []
        let localArray = {
            value: "Inc",
            label: "Increase Inventory",
        }
        let localArray1 = {
            value: "Dec",
            label: "Decrease Inventory",
        }
        AdjTypeValue.push(localArray);
        AdjTypeValue.push(localArray1)
        this.setState({ AdjTypeOptions: AdjTypeValue });

    };
    /***
    * MSA_PC_16
    * */
    ReasonDD = (Reason) => {

        let ReasonDDvalue = []
        let locArray = []
        if (Reason.length > 0) {
            Reason.map((val, index) => {
                let locObj = {
                    value: val.REASON_CD,
                    label: val.DESCR,
                }
                if (val.REASON_CD == "CREDITCARD") {
                    ReasonDDvalue.push(locObj)
                }
                else {
                    locArray.push(locObj)
                }
            });
            ReasonDDvalue.push(...locArray);
        }
        this.setState({ ReasonOptions: ReasonDDvalue });

    };
    /***
    * MSA_PC_17
    * */
    //To handle ItemId, Inc 0 qty locations checkbox, Adjust Quantity, Notes, Adjustment type fields
    OnHandleChange = (e, type) => {

        const costre = SDIConstants.CostRegEx;
        const re = SDIConstants.quantityRegEX;
        const numExp = /^\d+$/;
        let RegExp = /^\d*\.?\d*$/;
        let specExp = /^[a-zA-Z0-9\s]*$/;
        let reg = SDIConstants.numberRegEX;
        let Value;
        let val;
        if (type == "ItemId") {
            if (specExp.test(e.target.value.trim())) {
                Value = e.target.value.trim();

                if (Value.length == 9) {
                    let SearchItemBO = {
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        ItemId: Value,
                        Inc0Qtyavail: this.state.Inc0Qtychk,
                        UserId: isFromFieldInventory ? FieldUserId : CookieService.getLocalStorageValues("Session_UserID"),
                        TruckLocation: this.state.truckLocation,
                        IsTrucUser: CookieService.getLocalStorageValues("Session_TRUCK_USER"),
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    if (isFromLink) {
                        let itemIdtxt = document.getElementById('ItemIdid');
                        itemIdtxt.blur()
                    }
                    //CPW-246/234 To set Inc0Qtychk as true incase of Truck stock users - Vishwa S
                    this.setState({
                        [e.target.name]: Value,
                        Document: "", AdjQuantity: "", ReasDDName: "", AdjTypeValue: "", SelectedAdjTypes: {}, GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "", itemErrorMsg: "", adjTypeErrorMsg: "", adjQtyErrorMsg: "", adjQtyMsg: "", adjResonErrorMsg: "", adjNoteErrorMsg: "", TruckDDName: "",
                        itemMfg: "", itemMfgPartNo: ""
                    });

                    ManualStockAdjustmentAction.SearchItem(SearchItemBO)
                }


                else if (Value.length > 9) {
                    //Do not set state the value when its length is greater than 9
                }
                else {
                    //CPW-246/234 To set Inc0Qtychk as true incase of Truck stock users - Vishwa S
                    if (isTruckCrib === true && isFromLink === true && Value.length === 0) {
                        this.setState({
                            [e.target.name]: e.target.value,
                            Inc0Qtychk: isTruckCrib, Document: "", AdjQuantity: "", ReasDDName: "", AdjTypeValue: "", SelectedAdjTypes: {}, GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "", itemErrorMsg: "", adjTypeErrorMsg: "", adjQtyErrorMsg: "", adjQtyMsg: "", adjResonErrorMsg: "", adjNoteErrorMsg: "", TruckDDName: "",
                            itemMfg: "", itemMfgPartNo: ""
                        });
                    } else {
                        if (Value.length === 0) {
                            this.setState({ Inc0Qtychk: isTruckCrib })
                        }
                        this.setState({
                            [e.target.name]: e.target.value,
                            Document: "", AdjQuantity: "", ReasDDName: "", AdjTypeValue: "", SelectedAdjTypes: {}, GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "", itemErrorMsg: "", adjTypeErrorMsg: "", adjQtyErrorMsg: "", adjQtyMsg: "", adjResonErrorMsg: "", adjNoteErrorMsg: "", TruckDDName: "",
                            itemMfg: "", itemMfgPartNo: ""
                        });
                    }
                }
            }
        }
        else if (type == "AdjQuantity") {

            if (e.target.value === '' || numExp.test(e.target.value)) {
                if (e.target.value != "0" && e.target.value.length <= 5) {
                    this.setState({ [e.target.name]: e.target.value, adjQtyErrorMsg: "" });
                }
                if ((parseInt(e.target.value) > this.state.SelectedCurQty) && this.state.AdjTypeName == "Inc") {
                    this.setState({ adjQtyMsg: "Adjusted quantity will be more than the maximum" })
                }
                else {
                    this.setState({ adjQtyMsg: "" })
                }

            }
        }
        else if (type == "checkbox") {
            if (this.state.ItemID && this.state.ItemID.trim() && this.state.itemErrorMsg == "") {
                this.SearchItemClick(e.target.checked);
            }
            this.setState({ [e.target.name]: e.target.checked });
        }
        else if (type == "Document") {
            this.setState({ [e.target.name]: e.target.value, adjNoteErrorMsg: "" });
        }
        else if (type == "Dec" || type == "Inc") {
            if (type == "Dec") {
                //Manual Stock Adjustment - Decrease Radio Button is Not working in Walmart laptops and Item Id is case sensitive - Deepthi
                $("#Dec").prop("checked", true);
                $("#Inc").prop("checked", false);
                this.setState({ DecInventory: true, IncInventory: false, AdjTypeName: "Dec", adjTypeErrorMsg: "" });
            }
            else {
                //Manual Stock Adjustment - Decrease Radio Button is Not working in Walmart laptops and Item Id is case sensitive - Deepthi
                $("#Inc").prop("checked", true);
                $("#Dec").prop("checked", false);

                this.setState({ DecInventory: false, IncInventory: true, AdjTypeName: "Inc", adjTypeErrorMsg: "" });


            }
        }
        //PC_CPW_241_21
        else if (type == "minQty") {
            if (e.target.value === '' || numExp.test(e.target.value)) {
                val = e.target.value.trim();
                this.setState({ [e.target.name]: val, minQtyErrorMsg: "" })
            }
        }
        //PC_CPW_241_22
        else if (type == "maxQty") {
            if (e.target.value === '' || numExp.test(e.target.value)) {
                val = e.target.value.trim();
                this.setState({ [e.target.name]: val, maxQtyErrorMsg: "" })
            }
        }
    };
    // To handle Radio button in the Inventory location grid
    OnHandleGridRadChange = (e, Gindex) => {

        let locGrid = this.state.GridArray;
        if (locGrid.length == 1) {
            return;
        }
        else if (locGrid.length > 1) {
            locGrid.forEach((value, index) => {
                if (index == Gindex) {
                    value.IsLocSelected = true;
                    //let id = "manradio" + index;
                    //$("#" + id).prop("checked", true);
                    let qtyArray = value.Quantity.split(" ");
                    let qty = parseInt(qtyArray[0]);
                    let mobileStateData = {
                        quantity: value.Quantity,
                        serialno: value.SERIAL_ID,
                        unitcount: value.UnitCost,
                        SelectedQty: qty
                    }
                    this.setState({
                        GridArray: locGrid, ItemDescription: value.DESCR254, SelectedArea: value.STORAGE_AREA, SelectedUOM: value.UNIT_OF_MEASURE,
                        SelectedAisle: value.STOR_LEVEL_1, SelectedRow: value.STOR_LEVEL_2, SelectedShelf: value.STOR_LEVEL_3, SelectedBin: value.STOR_LEVEL_4, SelectedBU: value.BUSINESS_UNIT, SelectedCurQty: parseInt(value.QuantityAvail), mobileStateData: mobileStateData
                    });
                }
                else {
                    value.IsLocSelected = false;
                }
            });
        }
    }

    /***
    * MSA_PC_18
    * */
    SearchItemClick = (isCheckBoxCheck) => {

        //[11/10/22, Bug - 2841 Manual Stock Adjustment_ Able to submit adjusted qty though the adjustment type is not provided, Dhevanesam R]
        if (this.state.ItemID != "") {
            let SearchItemBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ItemId: this.state.ItemID.toUpperCase().trim(),
                Inc0Qtyavail: isCheckBoxCheck,
                UserId: isFromFieldInventory ? FieldUserId : CookieService.getLocalStorageValues("Session_UserID"),
                TruckLocation: this.state.truckLocation,
                IsTrucUser: CookieService.getLocalStorageValues("Session_TRUCK_USER"),
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            if (this.state.truckLocation != "") {
                this.setState({ isTruckId: true })
            }
            if (isFromFieldInventory) {
                this.setState({
                    Document: "", AdjQuantity: "", ReasDDName: "", AdjTypeValue: "", SelectedAdjTypes: {}, SelectedCurQty: "", ReasDDValue: "", Inc0Qtychk: this.state.Inc0Qtychk
                });
            } else {
                this.setState({
                    Document: "", AdjQuantity: "", ReasDDName: "", AdjTypeValue: "", SelectedAdjTypes: {}, GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "", Inc0Qtychk: this.state.Inc0Qtychk,
                    itemMfg: "", itemMfgPartNo: ""
                });
            }
           
            ManualStockAdjustmentAction.SearchItem(SearchItemBO)
        }
        else {
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Item ID'
            }); */
            //  alert('Please Enter Item Id');
            this.setState({
                itemErrorMsg: "Please enter the item ID", Document: "", AdjQuantity: "", ReasDDName: "", AdjTypeValue: "", SelectedAdjTypes: {}, GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "",
                itemMfg: "", itemMfgPartNo: ""
            });
        }

    }


    QR_Scanner_Mob = () => {
        this.setState({ QR: true });
        $('#QR_Scanner_ManualPopup').modal('show');
        //// $('#BarcodeSacnnerid').removeClass('hide');
        // $("#BarcodeSacnnerid").show();
    }

    CloseQR_Mob = () => {
        $('#QR_Scanner_ManualPopup').modal('hide');
        // $('#BarcodeSacnnerid').addClass('hide');
        $("#BarcodeSacnnerid").hide();
        //$(this.scannerRef.current).hide();
    }

    handleScan_Mob = (err, data) => {
        if (data != null && data != undefined) {
            this.setState({
                ItemID: data.text, isQrScan: true
            })
            $('#QR_Scanner_ManualPopup').modal('hide');
            //$('#BarcodeSacnnerid').addClass('hide');
            $("#BarcodeSacnnerid").hide();
            //$(this.scannerRef.current).hide();
            this.SearchItemClick(this.state.Inc0Qtychk);
        }
        else {
            console.log("QR_ERROR", err);
        }
    }
    QR_Scanner = () => {
        this.setState({ QR: true });

    }

    QR_ScannerClick = () => {
        $('#QR_Scanner_ManualPopup').modal('show');
    }

    //closeModal = () => {
    //    $('#QR_Scanner_ManualPopup').modal('hide');
    //}
    CloseQR = () => {
        //this.setState({ QR: false });
        this.setState({ QR: false }, () => {
            //$('#BarcodeSacnnerid').modal('hide');
            $('#QR_Scanner_ManualPopup').modal('hide');
            //$('#QR_Scanner_Popup').modal('hide');
        });
    }

    handleQRScan = (err, data) => {
        console.error("QRSCANNER", data);
        let truckCheck = this.state.Inc0Qtychk;
        if (isTruckCrib) {
            truckCheck = true
        }
        if (data != null && data != undefined) {
            $('#QR_Scanner_ManualPopup_Manual').modal('hide');
            this.setState({
                ItemID: data.text, QR: false, Inc0Qtychk: truckCheck
            })
            this.SearchItemClick(this.state.Inc0Qtychk);
        }
        else {
            console.log("QR_ERROR", err);
        }
    }



    handleQRScanError = () => {

        this.setState({ QRError: true })
    }

    handleOpenQR = () => {
        this.setState({ QR: true })
    }

    handleCloseQR = () => {
        $('#QR_Scanner_ManualPopup_Manual').modal('hide');
        this.setState({ QR: false })
    }

    /***
    * MSA_PC_20
    * */
    SearchItemClickResponse = () => {

        let SearchItemData = JSON.parse(ManualStockAdjustmentStore.SearchItemData);
        let itemErrorMsg
        if (isFromFieldInventory && SearchItemData === "Item is not available in crib") {
            let GridArray = this.state.GridArray;

           
            const unitOfMeasure = GridArray&&GridArray[0] ? GridArray[0].QuantityAvail.split(" ")[1] : ' ';
            IsInvalidItem = true;          
            GridArray[0] = {
                ...GridArray[0],
                QTY: 0, 
                QuantityAvail: `0 ${unitOfMeasure}`, 
                Quantity: `0 ${unitOfMeasure}`, 
                STORAGE_AREA: this.state.truckLocation,
            };

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Item with zero quantity is only available in the crib.'
            });
            this.setState({
                Inc0Qtychk: true,
                GridArray: GridArray
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return; 
        }
        if (SearchItemData == "Invalid Item ID") {
            canShowDetail = false;
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter valid Item ID '
            });*/
            // alert('Please Enter Valid Item ID ');
            //[11/10/22, Bug - 2841 Manual Stock Adjustment_ Able to submit adjusted qty though the adjustment type is not provided, Dhevanesam R]
            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            this.setState({
                itemErrorMsg: "Please enter valid Item ID ", Document: "", AdjQuantity: "", SelectedAdjTypes: {}, ReasDDName: "", AdjTypeValue: "", GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "",
                itemMfg: "", itemMfgPartNo: ""
            });            
            return;            
        }
        else if (SearchItemData == "Item is not available in crib") {
            canShowDetail = false;
            if (this.state.truckLocation == "") {
                itemErrorMsg = "Item is not available in crib"
            }
            else {
                itemErrorMsg = "This item id is not available for the selected Truck or Rack ID"
                this.setState({
                    isTruckId: true
                });
            }

            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            this.setState({
                itemErrorMsg: itemErrorMsg, Document: "", AdjQuantity: "", SelectedAdjTypes: {}, ReasDDName: "", AdjTypeValue: "", GridArray: [], ItemDescription: [], SelectedCurQty: "", ReasDDValue: "",
                itemMfg: "", itemMfgPartNo: ""
            });
            return;            

        }

        let SearchData = SearchItemData.ResultTable;
        let ItemDesData = SearchItemData.ItemDesTable;
        let itemMfgData = SearchItemData.ItemMFGTable;
        let ItemDesc = "";
        let truck = "";
        let isCheck = "";
        let selBu = "";
        let selArea = "";
        let selAisle = "";
        let selRow = "";
        let selShelf = "";
        let selBin = "";
        let selcurQty;
        let selUom;
        if (SearchData == undefined && ItemDesData == undefined) {
            canShowDetail = false;
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select Crib ID from User Profile"
            });
            //alert("Please Select Crib Id from User Profile");
        }
        else {
            //WW-553 MSA_PC_04  Issue due to zero qty-Manual stk - Deepthi N H
            //if (SearchData.length != 0) {
            //    canShowDetail = true;
            //}
            //if (SearchData.length == 0 && isFromLink == true) {
            //    canShowDetail = false;
            //    swal({
            //        allowOutsideClick: false,
            //        closeOnClickOutside: false,
            //        text: "Physical inventory not found for item"
            //    });
            //}
            let finalSearchres = [];
            if (!this.state.Inc0Qtychk) {
                SearchData.forEach((value, index) => {
                    if ((parseInt(value.QTY) - parseInt(value.QTY_RESERVED)) > 0) {
                        finalSearchres.push(value);
                    }
                    isCheck = false;
                });
                // SearchData.filter((val, idx) => (parseInt(val.QTY) - parseInt(val.QTY_RESERVED)) > 0)    
                if (finalSearchres.length <= 0) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'Item with zero quantity is only available in the crib'
                    });
                    finalSearchres = SearchData;
                    isCheck = true;
                }
            }
            else {
                finalSearchres = SearchData;
                isCheck = true
            }
            let mfg = ""
            let mfgPartNo = ""
            if (itemMfgData && itemMfgData.length > 0) {
                mfg = itemMfgData[0].MFG_ID
                mfgPartNo = itemMfgData[0].MFG_ITM_ID
            }
            if (finalSearchres.length > 0) {
                finalSearchres.forEach((value, index) => {
                    value.IsLocSelected = false;
                });
                //let localArray = {
                //    BUSINESS_UNIT:"C0W01",
                //    INV_ITEM_ID:"W01000025",
                //        SERIAL_ID:"NONE",
                //    STORAGE_AREA:"MAIN",
                //        STOR_LEVEL_1:"A",
                //    STOR_LEVEL_2:"B",
                //        STOR_LEVEL_3:"C",
                //    STOR_LEVEL_4:"D",
                //    UNIT_OF_MEASURE:"EA",
                //    QuantityAvail:"180.0000",
                //    Quantity: "190.0000",
                //    UnitCost: "1.0000",
                //    IsLocSelected:false
                //}
                //SearchData.push(localArray);
                /**finalSearchres[0].IsLocSelected = true;
                selBu = finalSearchres[0].BUSINESS_UNIT;
                selArea = finalSearchres[0].STORAGE_AREA;
                selAisle = finalSearchres[0].STOR_LEVEL_1;
                selRow = finalSearchres[0].STOR_LEVEL_2;
                selShelf = finalSearchres[0].STOR_LEVEL_3;
                selBin = finalSearchres[0].STOR_LEVEL_4;
                selcurQty = finalSearchres[0].QuantityAvail;
                selUom = finalSearchres[0].UNIT_OF_MEASURE;
                let qtyArray = finalSearchres[0].Quantity.split(" ");
                let qty = parseInt(qtyArray[0]);
                let mobileStateData = {
                    quantity: finalSearchres[0].Quantity,
                    serialno: finalSearchres[0].SERIAL_ID,
                    unitcount: finalSearchres[0].UnitCost,
                    SelectedQty: qty
                } */
                let HasOpenPO = false;
                if (ItemDesData != undefined) {
                    if (ItemDesData.length > 0) {
                        HasOpenPO = ItemDesData[0].HasOpenPO;
                        HasOpenPO = HasOpenPO == "False" ? false : true;
                    }
                }
                /**if (finalSearchres.length == 0) {
                   
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'This item has 0 quantity locations'
                    });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    return;
                } */
                if (this.state.truckLocation != "") {
                    truck = true
                }
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({
                    GridArray: finalSearchres, ItemID: this.state.ItemID, ItemDescription: SearchData[0].DESCR254, hasOpenPO: HasOpenPO, itemErrorMsg: "", Inc0Qtychk: isCheck, isTruckId: truck,
                    itemMfg: mfg, itemMfgPartNo: mfgPartNo
                });
            }
            else {
                if (ItemDesData.length > 0) {
                    ItemDesc = ItemDesData[0].ItemDescription;
                    if (ItemDesc != null && ItemDesc != undefined && ItemDesc != "") {


                        canShowDetail = false;
                        if (this.state.truckLocation == "") {
                            this.setState({
                                ItemDescription: ItemDesc, itemErrorMsg: "Item is not available in crib", GridArray: [], isTruckId: false, Inc0Qtychk: this.state.Inc0Qtychk,
                                itemMfg: mfg, itemMfgPartNo: mfgPartNo
                            });
                        }
                        else {
                            this.setState({
                                ItemDescription: ItemDesc, itemErrorMsg: "This item id is not available for the selected Truck or Rack ID", GridArray: [], isTruckId: true, truckLocation: this.state.truckLocation, Inc0Qtychk: this.state.Inc0Qtychk,
                                itemMfg: mfg, itemMfgPartNo: mfgPartNo
                            });
                        }

                        /**if (isFromLink) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Physical inventory not found for item"
                            });
                        }
                        else {
                            this.setState({
                                ItemDescription: ItemDesc, PhyInvMsg: "Physical inventory not found for item.", GridArray: ""
                            });
                        }*/
                    }
                }
            }
        }
        console.log("Addedarray", this.state.GridArray);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /***
    * MSA_PC_21
    * */

    SubmitClick = () => {

        let spccharctregex = /^[A-Za-z0-9 ]+$/;
        //let AdjQtyType = /^\d+$/.test(this.state.AdjQuantity);
        //Validate TextBox value against the Regex.
        let isValid = spccharctregex.test(this.state.Document);
        if ((Object.keys(this.state.SelectedAdjTypes).length == 0 || this.state.AdjTypeValue == "") && (this.state.ReasDDName == "" || this.state.ReasDDName == null) && (this.state.AdjQuantity == "")) {
            this.setState({ adjTypeErrorMsg: "Please select adjustment type", adjResonErrorMsg: "Please select reason", adjQtyErrorMsg: "Please enter quantity" })
        }
        if (this.state.Document != "") {
            if (!isValid) {
                /**swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please do not enter special characters in notes"
                });*/
                // alert("Please do not enter special characters in notes");
                this.setState({ adjNoteErrorMsg: "Please remove special character" })
                return;
            }
        }
        if (this.state.ItemID == "") {
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Item ID to adjust quantity'
            });*/
            //alert('Please Enter Item ID To Adjust Quantity');
            this.setState({ itemErrorMsg: "Please enter Item ID to adjust quantity" })
        }
        //To change radio buttons to dropdown - Deepthi N H
        //Prod Issue(Showing alert even if the radio button is selected) - Deepthi
        if (Object.keys(this.state.SelectedAdjTypes).length == 0 || this.state.AdjTypeValue == "") {
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select Adjustment Type'
            });*/
            //  alert('Please Select Adjustment Type');
            this.setState({ adjTypeErrorMsg: "Please select adjustment type" })
        }
        if (this.state.ReasDDName == "" || this.state.ReasDDName == null) {
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select reason for adjustment'
            });*/
            this.setState({ adjResonErrorMsg: "Please select reason" })
        }
        if (this.state.GridArray.length < 1) {
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter valid Item ID'
            });*/
            // alert('Please Enter Valid Item ID');
            this.setState({ itemErrorMsg: "Please enter valid Item ID" })
        }

        if (this.state.AdjQuantity == "") {
            /**swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter a valid quantity to adjust'
            });*/
            //  alert('Please Enter Quantity To Adjust');
            this.setState({ adjQtyErrorMsg: "Please enter quantity" })
        }
        if ((Object.keys(this.state.SelectedAdjTypes).length != 0 && this.state.AdjTypeValue != "") && (this.state.ReasDDName != "" && this.state.ReasDDName != null) && (this.state.AdjQuantity != "")) {
            if (this.AdjustedQuantity() != false) {
                if (this.state.AdjTypeName == "Inc") {
                    if (this.state.hasOpenPO) {
                        //CPW-303 Manual stock adjustment pageload query change for truck users 09/04/2024
                        $('.edit-adjustment').modal('hide');
                        if (isFromLink == true) {
                            $('#HasOpenPOPopUpMob').modal('show');
                        }
                        else {
                            $('#HasOpenPOPopUp').modal('show');
                        }
                    }
                    else {
                        /**$('#AdjustmentConfPopUp').modal('show');
                        if (isFromLink == true) {
                            $('#mobileAdjustPopUp').modal('show');
                        }*/
                        //PC_CPW_231_05 
                        if ((this.state.truckLocation == "" || this.state.truckLocation != "") && isFromLink == false || (isFromLink == true && this.state.truckLocation == "")) {
                            this.AdjConfSubmitClick()

                        }
                        //PC_CPW_231_06
                        else {
                            if (this.reorderCheck()) {
                                if (this.state.reorderRes == true) {
                                    this.AdjConfSubmitClick()
                                }
                            }

                        }

                    }
                }
                else {
                    /**$('#AdjustmentConfPopUp').modal('show');
                    if (isFromLink == true) {
                        $('#mobileAdjustPopUp').modal('show');
                    }*/
                    //PC_CPW_231_07 
                    if (((this.state.truckLocation == "" || this.state.truckLocation != "") && isFromLink == false) || (isFromLink == true && this.state.truckLocation == "")) {
                        this.AdjConfSubmitClick()
                    } //PC_CPW_231_08
                    else {
                        if (this.reorderCheck()) {
                            if (this.state.reorderRes == true) {
                                this.AdjConfSubmitClick()
                            }
                        }

                    }
                }

            }
            else {
                return;
            }
        }
    }

    //PC_CPW_231_09
    reorderCheck = () => {
        let ReorderBO = {
            ItemId: this.state.ItemID,
            Area: this.state.SelectedArea,
            Aisle: this.state.SelectedAisle,
            Row: this.state.SelectedRow,
            Shelf: this.state.SelectedShelf,
            Bin: this.state.SelectedBin
        }
        //PC_CPW_231_10
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ManualStockAdjustmentAction.reorderCheckAction(ReorderBO)
    }

    //PC_CPW_231_18
    reorderCheckResponse = () => {

        let reorderResponse = JSON.parse(ManualStockAdjustmentStore.reorderdata);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        if (reorderResponse == "False") {
            //PC_CPW_231_19  
            this.AdjConfSubmitClick()
            $('.edit-adjustment').modal('hide');
            this.setState({ reorderRes: true })
        }
        //PC_CPW_231_20
        else if (reorderResponse == "True") {
            $('.edit-adjustment').modal('hide');
            $('#ReorderPointPopup').modal('show');
            this.setState({ reorderRes: false })

        }

        else {
            $('.edit-adjustment').modal('hide');
            $('#FailedPopup').modal('show');
            this.setState({ reorderRes: false })
        }
    }

    //PC_CPW_231_23
    reorderSubmit = () => {

        const minQty = parseInt(this.state.minQty);
        const maxQty = parseInt(this.state.maxQty);
        if (this.state.minQty == "" && this.state.maxQty == "") {
            this.setState({ minQtyErrorMsg: "Please enter min quantity", maxQtyErrorMsg: "Please enter max quantity" })
        }
        else if (this.state.minQty == "") {
            this.setState({ minQtyErrorMsg: "Please enter min quantity" })
        }
        //PC_CPW_231_24
        else if (this.state.maxQty == "") {
            this.setState({ maxQtyErrorMsg: "Please enter max quantity" })
        }
        //else if (this.state.minQty == 0) {
        //    this.setState({ minQtyErrorMsg: "Please enter valid quantity" })
        //}
        //else if (this.state.maxQty == 0) {
        //    this.setState({ minQtyErrorMsg: "Please enter valid quantity" })
        //}
        //PC_CPW_231_25
        else if (maxQty < minQty) {
            this.setState({ minQtyErrorMsg: " Minimum value should not be greater than maximum value" })
        }
        else {
            //PC_CPW_231_26
            let ReorderSubmitBO = {
                ItemId: this.state.ItemID,
                Area: this.state.SelectedArea,
                Aisle: this.state.SelectedAisle,
                Row: this.state.SelectedRow,
                Shelf: this.state.SelectedShelf,
                Bin: this.state.SelectedBin,
                maxQty: this.state.maxQty,
                minQty: this.state.minQty
            }
            //PC_CPW_231_27
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ManualStockAdjustmentAction.reorderSubmitAction(ReorderSubmitBO)
        }
    }

    //PC_CPW_231_32
    reorderSubmitResponse = () => {

        let reorderSubmitResponse = JSON.parse(ManualStockAdjustmentStore.submitReorder);
        //PC_CPW_231_33
        if (reorderSubmitResponse == "Updated Successfully") {
            $('#ReorderPointPopup').modal('hide');
            this.AdjConfSubmitClick()
        }
        //PC_CPW_231_35
        else {
            $('#ReorderPointPopup').modal('hide');

            $('#Failedpopup').modal('show');

            this.setState({
                GridArray: [], ItemID: "", ReasDDValue: "", Document: "", ReasDDName: "", AdjTypeValue: "", AdjQuantity: "",
                AdjustedQty: "", TruckDDName: "", ItemDescription: "", AdjTypeName: "", minQtyErrorMsg: "", maxQtyErrorMsg: "", minQty: "", maxQty: "",
                Inc0Qtychk: false, isTruckCrib: false, DecInventory: false, IncInventory: false, isTruckId: false, SelectedAdjTypes: {}, itemMfg: "", itemMfgPartNo: ""
            })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    //PC_CPW_231_37
    reOrderCancelClick = () => {
        $('#ReorderPointPopup').modal('hide');
        $('.edit-adjustment').modal('show');
        //PC_CPW_231_38
        this.setState({ minQty: "", maxQty: "", minQtyErrorMsg: "", maxQtyErrorMsg: "" })
    }
    NoClick = () => {
        if (isFromLink == true) {
            $('#HasOpenPOPopUpMob').modal('hide');
        }
        else {
            $('#HasOpenPOPopUp').modal('hide');
        }
        //CPW-303 Manual stock adjustment pageload query change for truck users 09/04/2024
        this.setState({
            ReasDDName: "", ReasDDValue: "", Document: "",
            AdjQuantity: "", DecInventory: false, IncInventory: false, AdjTypeValue: "", AdjTypeName: "",
            AdjustedQty: "", itemErrorMsg: "", adjTypeErrorMsg: "", adjQtyErrorMsg: "", adjResonErrorMsg: "", adjNoteErrorMsg: "", adjQtyMsg: "", maxQty: "", minQty: ""
        })

    }
    YesClick = () => {
        if (isFromLink == true) {
            $('#HasOpenPOPopUpMob').modal('hide');
            //CPW-303 Manual stock adjustment pageload query change for truck users 09/04/2024
            this.AdjConfSubmitClick()
            //  $('#mobileAdjustPopUp').modal('show');
        }
        else {
            $('#HasOpenPOPopUp').modal('hide');
            this.AdjConfSubmitClick()
            //  $('#AdjustmentConfPopUp').modal('show');
        }
    }
    // To adjust the quantity with the current quantity available  
    AdjustedQuantity = () => {

        let QtyAdjusted;
        if (this.state.AdjTypeName == "Dec") {

            if (parseInt(this.state.AdjQuantity) > parseInt(this.state.SelectedCurQty)) {
                /**swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Quantity to be adjusted should not be greater than available quantity'
                });*/
                this.setState({
                    adjQtyErrorMsg: "Adjustment qty should be less than available qty"
                })
                // alert('Quantity to be adjusted should not be greater than available quantity');
                return false;
            }
            else {
                QtyAdjusted = parseInt(this.state.SelectedCurQty) - parseInt(this.state.AdjQuantity);
            }
        }
        else {
            QtyAdjusted = parseInt(this.state.SelectedCurQty) + parseInt(this.state.AdjQuantity);
        }
        if (QtyAdjusted == 0) {
            this.setState({ AdjustedQty: QtyAdjusted });
            return true
        }
        if (QtyAdjusted != null && QtyAdjusted != undefined && QtyAdjusted != "") {
            this.setState({ AdjustedQty: parseInt(QtyAdjusted) });
            return true
        }

    }
    OkBtnClick = () => {
        $('#successpopup').modal('hide');
        $('#Failedpopup').modal('hide');

        //CPW-246/234 To set Inc0Qtychk as true incase of Truck stock users - Vishwa S
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        IsInvalidItem = false;
        this.setState({
            GridArray: [], Inc0Qtychk: isTruckCrib, ItemDescription: "", ReasDDName: "", ReasDDValue: "", Document: "", isTruckId: false,
            AdjQuantity: "", DecInventory: false, IncInventory: false, SelectedAdjTypes: {}, AdjTypeValue: "", minQtyErrorMsg: "", maxQtyErrorMsg: "", minQty: "", maxQty: "",
            AdjTypeName: "", AdjustedQty: "", TruckDDName: "", itemErrorMsg: "", adjTypeErrorMsg: "", adjQtyErrorMsg: "", adjQtyMsg: "", adjResonErrorMsg: "", adjNoteErrorMsg: "",
            itemMfg: "", itemMfgPartNo: ""
        })

        this.SearchItemClick(isTruckCrib);

    }

    ClearItemId = () => {
        if (isTruckCrib === true && isFromLink === true) {
            this.setState({ Inc0Qtychk: true });
        } else {
            this.setState({ Inc0Qtychk: false });
        }
        this.setState({ ItemID: "", itemErrorMsg: "", GridArray: [], truckLocation: this.state.defTruckId, isTruckId: false })
    }

    /***
    * MSA_PC_22
    * */
    AdjConfSubmitClick = () => {

        let Reason = this.state.SelectedRes.value;
        //Manual Stock Adjustment - Decrease Radio Button is Not working in Walmart laptops and Item Id is case sensitive - Deepthi
        let AdjConfSubmitBO = {
            ItemId: this.state.ItemID.toUpperCase(),
            Inc0Qtyavail: this.state.Inc0Qtychk,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_UserID: isFromFieldInventory ? FieldUserId : CookieService.getLocalStorageValues("Session_UserID"),
            SelectedBU: this.state.SelectedBU,
            ItemID: this.state.ItemID.toUpperCase(),
            Reason: Reason,
            Document: this.state.Document,
            Quantity: this.state.AdjQuantity,
            SerialId: this.state.SerialId,
            Area: this.state.SelectedArea,
            Aisle: this.state.SelectedAisle,
            Row: this.state.SelectedRow,
            Shelf: this.state.SelectedShelf,
            Bin: this.state.SelectedBin,
            UOM: this.state.SelectedUOM,
            AdjType: this.state.AdjTypeName == "Dec" ? "D" : "I",
            AdjustedQty: this.state.AdjustedQty,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            IsInvalidItem: IsInvalidItem,
            Region: Region,
            Sub_Region: Sub_Region,        
        }
        //$('#AdjustmentConfPopUp').modal('hide');
        //$('#mobileAdjustPopUp').modal('hide');
        canShowDetail = false;
        $('.edit-adjustment').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ManualStockAdjustmentAction.AdjConfSubmit(AdjConfSubmitBO)
    }
    /***
    * MSA_PC_25
    * */

    AdjConfCancelClick = () => {
        this.setState({
            ReasDDName: "", ReasDDValue: "", Document: "",
            AdjQuantity: "", DecInventory: false, IncInventory: false, AdjTypeValue: "", AdjTypeName: "",
            AdjustedQty: "", itemErrorMsg: "", adjTypeErrorMsg: "", adjQtyErrorMsg: "", adjResonErrorMsg: "", adjNoteErrorMsg: "", adjQtyMsg: "", maxQty: "", minQty: ""
        })
    }

    AdjConfSubmitClickResponse = () => {

        let AdjConfSubmitRes = JSON.parse(ManualStockAdjustmentStore.AdjConfSubmitRes);

        if (AdjConfSubmitRes == "The adjustment was successful.") {
            $('.edit-adjustment').modal('hide');
            $('#successpopup').modal('show');
        }
        else {
            $('.edit-adjustment').modal('hide');
            $('#Failedpopup').modal('show')
        }
        //To change radio buttons to dropdown - Deepthi N H
        //CPW-246/234 To set Inc0Qtychk as true incase of Truck stock users - Vishwa S
        this.setState({ AdjMessage: AdjConfSubmitRes })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    onHandleAdjEdit = (e, index) => {

        $('.edit-adjustment').modal('show');

        let selBu = "";
        let selArea = "";
        let selAisle = "";
        let selRow = "";
        let selShelf = "";
        let selBin = "";
        let selcurQty;
        let selUom;

        this.state.GridArray[index].IsLocSelected = true;
        selBu = this.state.GridArray[index].BUSINESS_UNIT;
        selArea = this.state.GridArray[index].STORAGE_AREA;
        selAisle = this.state.GridArray[index].STOR_LEVEL_1;
        selRow = this.state.GridArray[index].STOR_LEVEL_2;
        selShelf = this.state.GridArray[index].STOR_LEVEL_3;
        selBin = this.state.GridArray[index].STOR_LEVEL_4;
        selcurQty = this.state.GridArray[index].QuantityAvail;
        selUom = this.state.GridArray[index].UNIT_OF_MEASURE;
        let qtyArray = this.state.GridArray[index].Quantity.split(" ");
        let zeroqtycheck = this.state.GridArray[index].QTY;
        let adjustfieldvalue = this.state.AdjTypeValue;
        let AdjTypeName = this.state.AdjTypeName;
        
        let qty = parseInt(qtyArray[index]);
        let AdjTypeValue = [];
        if (zeroqtycheck === 0) {
            AdjTypeName= "Inc"
            adjustfieldvalue= { value: 'Inc', label: 'Increase Inventory' }
            let localArray = {
                value: "Inc",
                label: "Increase Inventory",
            }
            AdjTypeValue.push(localArray);
        } else {
            let localArray = {
                value: "Inc",
                label: "Increase Inventory",
            }
            let localArray1 = {
                value: "Dec",
                label: "Decrease Inventory",
            }
            AdjTypeValue.push(localArray);
            AdjTypeValue.push(localArray1)
        }
        let mobileStateData = {
            quantity: this.state.GridArray[index].Quantity,
            serialno: this.state.GridArray[index].SERIAL_ID,
            unitcount: this.state.GridArray[index].UnitCost,
            SelectedQty: qty
        }

        this.setState({
            GridArray: this.state.GridArray, SelectedArea: selArea, SelectedUOM: selUom,
            SelectedAisle: selAisle, SelectedRow: selRow, SelectedShelf: selShelf, SelectedBin: selBin, SelectedBU: selBu, SelectedCurQty: parseInt(selcurQty), itemErrorMsg: "", mobileStateData: mobileStateData, AdjTypeOptions: AdjTypeValue, AdjTypeValue: adjustfieldvalue, AdjTypeName,
            SelectedAdjTypes: adjustfieldvalue,
        });
    }

    // To bind the Inventory location details grid
    BindGridData = () => {

        if (this.state.GridArray.length > 0) {
            return this.state.GridArray.map((value, index) => {
                let QtyWhole = parseInt(value.Quantity);
                let QtyAvailWhole = parseInt(value.QuantityAvail);
                return (<React.Fragment key={index}>{value.INV_ITEM_ID != "" ? <>
                    <tr>
                        <td >{value.BUSINESS_UNIT}</td>
                        <td >{QtyWhole}</td>
                        <td >{QtyAvailWhole}</td>
                        <td >{value.SERIAL_ID}</td>
                        <td >{value.STORAGE_AREA}</td>
                        <td >{value.STOR_LEVEL_1}</td>
                        <td >{value.STOR_LEVEL_2}</td>
                        <td >{value.STOR_LEVEL_3}</td>
                        <td >{value.STOR_LEVEL_4}</td>
                        <td className="text-nowrap text-center"><a href="#" className="mr-3" data-toggle="modal" data-target=".edit-adjustment" onClick={(e) => this.onHandleAdjEdit(e, index)}><img src="images/edit-icon.svg" alt="delete" /></a></td>
                    </tr>
                </> : null}
                </React.Fragment>

                );

            })

        }
    }

    setValue = (index) => {
        this.setState({ selectedIndex: index })
    }

    bindListView = () => {
        if (this.state.GridArray.length > 0) {
            return (
                <React.Fragment>
                    {this.state.GridArray.map((value, index) => {
                        let QtyWhole = parseInt(value.Quantity);
                        let QtyAvailWhole = parseInt(value.QuantityAvail);
                        return (
                            <React.Fragment key={index}>
                                {value.INV_ITEM_ID !== "" &&
                                    <React.Fragment>
                                        {/* row-1 starts here */}
                                        <tr>
                                            <td data-toggle="collapse" data-target="#order-row-1" className="accordion-toggle collapsed"><span className="accordion-arrow accordion-arrow-change" /></td>
                                            <td>{value.BUSINESS_UNIT}</td>
                                            <td>{QtyAvailWhole}</td>
                                            <td className="text-center" id={`arrow-${index}`}><a href="#" data-toggle="modal" data-target=".edit-adjustment"><img src="images/edit-icon.svg" alt="edit" onClick={(e) => this.onHandleAdjEdit(e, index)} /></a></td>
                                        </tr>
                                        {/* row-1 ends here */}
                                        {/* accordion starts here */}
                                        <tr className="p">
                                            <td colSpan={4} className="hiddenRow border-bottom-0">
                                                <div className="accordian-body collapse py-1 border-bottom" id={`order-row-${index + 1}`}>
                                                    <div className="px-3 py-2">
                                                        <div className="row custom-bg pt-3">
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Qty :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{QtyWhole}</span>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Serial ID :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{value.SERIAL_ID}</span>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Area :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{value.STORAGE_AREA}</span>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Aisle :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{value.STOR_LEVEL_1}</span>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Row :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{value.STOR_LEVEL_2}</span>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Shelf :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{value.STOR_LEVEL_3}</span>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <span className="font-14 font-medium label-color">Bin :</span>
                                                                <span className="font-14 font-regular ml-1 label-value-color">{value.STOR_LEVEL_4}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        {/* accordion ends here */}
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        );
                    })}
                </React.Fragment>
            );
        }
    }

    bindSelectedGrid = () => {

        return (
            <div className="selected-information-section mt-2">
                <h5 className="release-notes-heading release-notes-color font-weight-bold mt-2">Selected Information</h5>
                <span className="d-block">
                    <span className="radio-button-section-heading">BU:</span>
                    <span> </span>
                    <span className="radio-button-section-value">{this.state.SelectedBU}</span>
                </span>
                <span className="d-block mt-2">
                    <span className="radio-button-section-heading">Quantity :</span>
                    <span> </span>
                    <span className="radio-button-section-value">{this.state.mobileStateData.quantity}</span>
                </span>
                <span className="d-block mt-2">
                    <span className="radio-button-section-heading">Quantity Available :</span>
                    <span> </span>
                    <span className="radio-button-section-value">{this.state.SelectedCurQty}</span>
                </span>
                <span className="d-block mt-2">
                    <span className="radio-button-section-heading">Serial ID :</span>
                    <span> </span>
                    <span className="radio-button-section-value">{this.state.mobileStateData.serialno}</span>
                </span>
                <span className="d-block mt-2">
                    <span className="radio-button-section-heading">Bin Location :</span>
                    <span> </span>
                    <span className="radio-button-section-value">
                        {this.state.SelectedArea} {this.state.SelectedAisle} {this.state.SelectedRow} {this.state.SelectedShelf} {this.state.SelectedBin}
                    </span>
                </span>
                {/*<span className="d-block mt-2">
                        <span className="radio-button-section-heading">Unit Cost :</span>
                        <span> </span>
                        <span className="radio-button-section-value">{this.state.mobileStateData.unitcount}</span>
                    </span>*/}
            </div>
        );

    };

    //To handle the favorite page
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Manual Stock Adjustment",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ManualStockAdjustmentAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ManualStockAdjustmentAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        if (!isFromFieldInventory) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        let favPageResponse = JSON.parse(ManualStockAdjustmentStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (ManualStockAdjustmentStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ManualStockAdjustmentStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ManualStockAdjustmentStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    navigateToFieldInventory = () => {
        this.props.history.push({
            pathname: '/FieldInventoryWorkbench',
            state: {
                DontClear: true
            }
        });

    };
    render() {
        return (

            <div className="container-fluid container-margin content-section" style={isFromLink ? { marginTop: "10px" } : {}}>
                <div className="row">
                    {/*Page Heading starts here*/}
                    <div className="col-md-12 mt-3 mb-4 page-heading">
                        <h5 className="page-title"> {this.state.isFromFieldInventory ? (
                            <span className="table-sort mr-2" onClick={this.navigateToFieldInventory}>
                                <img src="images/left-arrow.svg" alt="sort-up" />
                            </span>
                        ) : null}Manual Stock Adjustment</h5>
                        {!isFromLink ? <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-OrdStatus">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div> : null}
                    </div>
                    {/*Page Heading ends here*/}
                    {/*form starts here*/}
                    <div className="col-md-12">
                        <div className="row">
                            {isFromFieldInventory ?
                                <div style={{ "padding-left": "12px" }}>
                                    <label className="form-label catalog-label text-nowrap" htmlFor="ItemIdid">Item ID<span className="color-validation">*</span></label>
                                    <div className="position-relative">
                                        <label className="form-label catalog-label" style={{ width: "177px" }}>{this.state.ItemID}</label>
                                    </div>
                                </div> :
                                <div className="col-md-3 col-12 col-sm-12">
                                    <div className="d-flex justify-content-between align-items-end">
                                        <div>
                                            <label className="form-label catalog-label text-nowrap" htmlFor="ItemIdid">Item ID or QR<span className="color-validation">*</span></label>
                                            <div className="position-relative">
                                                <input type="text" name="ItemID" className="form-control validation custom-form-control override-width" style={{ width: "177px" }} id="ItemIdid" placeholder="Enter item ID or scan QR" value={this.state.ItemID} onChange={e => this.OnHandleChange(e, "ItemId")} disabled={this.state.disableInput} />
                                                {this.state.ItemID != undefined && this.state.ItemID != null && this.state.ItemID != "" && this.state.ItemID != " " ?
                                                    <span className="search-cancel-header cursor-pointer position-absolute" style={{ right: "5px", top: "48px" }} onClick={() => this.ClearItemId()} ></span> : null
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-3" style={{ marginLeft: "7px" }} onClick={() => { if (!this.state.disableInput) { this.SearchItemClick() } }}>Search</button>
                                        </div>
                                        <div className="custom-border-left mt-1">
                                            <a href="#" data-toggle="modal" data-target="#QR_Scanner_ManualPopup_Manual" data-backdrop="static" data-keyboard="false" onClick={() => this.handleOpenQR()}><img className="ml-3" src="images/qr-code.svg" alt="qr-code" /></a>
                                        </div>
                                    </div>
                                    {this.state.itemErrorMsg != "" ? <span className="font-12 font-regular color-validation w-100" >{this.state.itemErrorMsg}</span> : null}
                                </div>
                            }
                            {this.state.truckLocation != "" && this.state.isTruckId != false ?
                               
                                    <div className="col-md-3 col-12 col-sm-12 manual-stk-qr">
                                        <label className="form-label catalog-label w-100" htmlFor="truck-id">Truck or Rack ID<span className="color-validation">*</span></label>
                                        <Select
                                            id="truck-id"
                                            name="TruckData"
                                            onChange={(e) => this.handleTruckDDChange(e)}
                                            value={{ value: this.state.truckLocation, label: this.state.truckLocation }}
                                            options={this.state.TruckOptions}
                                        />
                                    </div>
                                : null}
                        </div>
                    </div>
                    <div className="col-md-12 mb-2 mt-2">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="defaultCheck1" name="Inc0Qtychk" checked={this.state.Inc0Qtychk} onChange={(e) => this.OnHandleChange(e, "checkbox")} defaultValue="option1" />
                            <label className="form-check-label font-14 font-regular" htmlFor="defaultCheck1">Include zero qty locations</label>
                        </div>
                    </div>
                    {/*form ends here*/}
                    {/*Item Details Grid*/}
                    {this.state.GridArray.length > 0 ?
                        <div className="col-md-12 mt-3">
                            <h5 className="font-16 font-bold">Item details</h5>
                                <div className="w-100 mb-2">
                                    <span className="font-14 font-medium">Description :</span>
                                    <span className="font-14 font-regular ml-1">{this.state.ItemDescription ? this.state.ItemDescription : "-"}</span>
                                </div>
                            <div>
                                <div className="w-100 mb-2">
                                    <span className="font-14 font-medium">Manufacturer Name :</span>
                                    <span className="font-14 font-regular ml-1">{this.state.itemMfg ? this.state.itemMfg : "-"}</span>
                                </div>
                                <div className="w-100 mb-2">
                                    <span className="font-14 font-medium">Manufacturer Part # :</span>
                                    <span className="font-14 font-regular ml-1">{this.state.itemMfgPartNo ? this.state.itemMfgPartNo : "-"}</span>
                                </div>
                            </div>

                            {!isFromLink ?
                                (<div className="table-responsive mb-3 ">
                                    <table className="table split-delv-table">
                                        <thead>
                                            <tr>
                                                <th>BU</th>
                                                <th>Qty</th>
                                                <th>Qty available</th>
                                                <th>Serial ID</th>
                                                <th>Area</th>
                                                <th>Aisle</th>
                                                <th>Row</th>
                                                <th>Shelf</th>
                                                <th>Bin</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.BindGridData()}
                                        </tbody>
                                    </table>
                                </div>) : null}

                        </div>
                        : null}

                    {/*Mobile Item Details Grid*/}
                    {this.state.GridArray.length > 0 && isFromLink ?
                        <div className="col-md-12 custom-displayNew">
                            {/*Table starts here*/}
                            <div className="table-responsive mt-2">
                                <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid">
                                    <thead>
                                        <tr>
                                            <th />
                                            <th>BU</th>
                                            <th>Qty available</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.bindListView()}
                                    </tbody>
                                </table>
                            </div>
                            {/*Table ends here*/}
                        </div>
                        : null}
                    {/*Mobile Grid ends here*/}

                </div>
                {/* CPW-303 Manual stock adjustment pageload query change for truck users 09/04/2024 */}

                <div className="modal" id="HasOpenPOPopUp">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.NoClick()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>This Item has open PO's, are you sure you want to adjust?</Trans></label>

                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.NoClick()}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.YesClick()}><Trans>Yes</Trans></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}
                <div className="modal" id="HasOpenPOPopUpMob">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.NoClick()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>This Item has open PO's, are you sure you want to adjust?</Trans></label>

                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.NoClick()}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.YesClick()}><Trans>Yes</Trans></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Adjustment Modal Starts here*/}
                <div className="modal fade edit-adjustment p-0" tabIndex={-1} role="dialog" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered edit-adjustment-custom-width" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">Edit adjustment</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={e => this.AdjConfCancelClick(e)}><img src="images/close-icon.svg" alt="close" /></button>
                            </div>
                            {/*Form Starts here*/}
                            <div className="modal-body dropdown-overlay">
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label catalog-label font-14 font-medium" htmlFor="adjType">Adjustment type<span className="color-manditory">*</span></label>
                                        <div className="float-left w-100">

                                            <Select
                                                options={this.state.AdjTypeOptions}
                                                value={this.state.AdjTypeValue}
                                                onChange={(e) => this.handleAdjTypeDDChange(e)}
                                                name="BuDD"
                                                id="adjType"
                                            />
                                            {this.state.adjTypeErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.adjTypeErrorMsg}</span> : null}

                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label catalog-label font-14 font-medium" htmlFor="ReasonId">Reason<span className="color-manditory">*</span></label>
                                        <div className="float-left w-100">
                                            <Select
                                                id="ReasonId"
                                                name="BuDD"
                                                onChange={(e) => this.handleReasDDChange(e)}
                                                value={this.state.ReasDDName}
                                                options={this.state.ReasonOptions}
                                            />
                                            {this.state.adjResonErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.adjResonErrorMsg}</span> : null}

                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label catalog-label font-14 font-medium" htmlFor="AdjQuantity">Adjust quantity<span className="color-manditory">*</span></label>
                                        <input type="text" className="form-control" maxLength={5} id="numericInput" name="AdjQuantity" value={this.state.AdjQuantity} onChange={e => this.OnHandleChange(e, "AdjQuantity")} placeholder="Enter quantity" />
                                        {this.state.adjQtyErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.adjQtyErrorMsg}</span> : null}
                                        {this.state.adjQtyMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.adjQtyMsg}</span> : null}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label catalog-label font-14 font-medium" htmlFor="Document">Notes</label>
                                        <input type="text" maxLength={11} className="form-control" id="Document" name="Document" value={this.state.Document} onChange={e => this.OnHandleChange(e, "Document")} placeholder="Enter notes" />
                                        {this.state.adjNoteErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.adjNoteErrorMsg}</span> : null}
                                    </div>
                                </div>
                            </div>
                            {/*Form ends here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 pt-1 mb-2">
                                <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" data-dismiss="modal" onClick={e => this.AdjConfCancelClick(e)}>Cancel</button>
                                <button className="btn btn-custom-primary font-14 font-medium px-4" onClick={e => this.SubmitClick(e)}>Submit</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>

                {/*Failure Modal Starts here*/}
                <div className="modal fade alert-role-popup" id="Failedpopup" tabIndex={-1} role="dialog" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content border-0 py-2">
                            {/*alert Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/alert-Icon.svg" alt="alert" />
                                        <p className="mb-1 font-14 font-regular color-light-black">Stock adjustment updation failed!</p>
                                    </div>
                                </div>
                            </div>
                            {/*alert end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={e => this.OkBtnClick(e)} data-dismiss="modal">OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*Failure Modal Ends here*/}

                {/*Success Modal Starts here*/}
                <div className="modal fade success-customer" id="successpopup" tabIndex={-1} role="dialog" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content border-0 py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/tick.svg" alt="tick" />
                                        <h5 className="mb-2 font-16 font-bold color-light-black">Success</h5>
                                        <p className="mb-1 font-14 font-regular color-light-black">Stock adjustment updated successfully!</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={e => this.OkBtnClick(e)}>OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*Success Modal Ends here*/}

                <div className="modal fade qr-scan" tabIndex={-1} role="dialog" aria-hidden="true" id="QR_Scanner_ManualPopup_Manual">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">QR scan</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => this.handleCloseQR()}><img src="images/close-icon.svg" alt="close" /></button>
                            </div>
                            {/*QR Starts here*/}
                            <div className="modal-body text-center my-4 overflow-hidden">
                                <div className="row mt-3">
                                    <div className="col-12 text-center  mb-4">
                                        {this.state.QRError == true ?
                                            <><img className="mt-2" src="images/camera-open-img.svg" alt="qr-code-camera" />
                                                <p className="mb-1 font-18 mt-5 font-medium color-light-black"><Trans>Please allow your browser to access your webcam</Trans></p>
                                                <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                                    <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={() => this.handleCloseQR()}><Trans>OK</Trans></button>
                                                </div>
                                            </> :
                                            this.state.QR == true ?
                                                <BarcodeScannerComponent
                                                    width="100%"
                                                    height={500}
                                                    onUpdate={this.handleQRScan}
                                                    facingMode={"environment"}
                                                    onError={this.handleQRScanError}

                                                /> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*QR ends here*/}
                    </div>
                </div>



                {/*Modal Starts here*/}
                <div className="modal fade edit-adjustment-reorder p-0" id="ReorderPointPopup" tabIndex={-1} role="dialog" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered edit-adjustment-custom-width" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">Edit adjustment</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={e => this.AdjConfCancelClick(e)}><img src="images/close-icon.svg" alt="close" /></button>
                            </div>
                            {/*Form Starts here*/}
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mb-3 mt-2">
                                        <div className="d-flex align-items-top">
                                            <div className="d-block">
                                                <img className="mr-2" src="images/info-icon-sdi.svg" alt="info-icon" />
                                            </div>
                                            <div className="d-block">
                                                <label className="font-14 font-medium mb-0">Please select reorder point and max stocking quantity for this item</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label catalog-label font-14 font-medium" htmlFor="min-quantity">Min quantity</label>
                                        <input type="text" className="form-control" id="min-quantity" name="minQty" maxLength={5} value={this.state.minQty} onChange={e => this.OnHandleChange(e, "minQty")} placeholder="Enter min quantity" />
                                        {this.state.minQtyErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.minQtyErrorMsg}</span> : null}
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label catalog-label font-14 font-medium" htmlFor="max-quantity">Max quantity</label>
                                        <input type="text" className="form-control" id="max-quantity" name="maxQty" maxLength={5} value={this.state.maxQty} onChange={e => this.OnHandleChange(e, "maxQty")} placeholder="Enter max quantity" />
                                        {this.state.maxQtyErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.maxQtyErrorMsg}</span> : null}
                                    </div>
                                </div>
                            </div>
                            {/*Form ends here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 pt-1 mb-2">
                                <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" data-dismiss="modal" onClick={e => this.reOrderCancelClick(e)}>Cancel</button>
                                <button className="btn btn-custom-primary font-14 font-medium px-4" onClick={e => this.reorderSubmit(e)}>Submit</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}

            </div>

        )
    }
}

export default withTranslation()(ManualStockAdjustmentComponent);